<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
  mixins: [fandomBasicMixin],
  props: ["propBookmark"],
  data() { 
    return {
      bookmark: this.propBookmark,
      unitNumber: 1
    } 
  },
  mounted() {
    this.$on("scroll-lock", () => {
      disableBodyScroll(this.$refs["courses"]);
    });
    this.$on("scroll-unlock", () => {
      clearAllBodyScrollLocks();
    });
  },
  methods: {
    setBookmark(chapter, index) {
      if (chapter.$id != this.bookmark.$id) {
        this.bookmark = chapter;
        this.unitNumber = index + 1;
        this.$emit('set-bookmark', { chapter: chapter, unitNumber: this.unitNumber });
      }
    },
    isChapterActive(chapter) {
      return  this.bookmark.$id == chapter.$id;
    },
    getIconClasses(chapter, section) {
      const weight = (section === this.unitNumber && chapter.$id <= this.bookmark.$id) ? "fas" : "far";
      const icon = this.isChapterActive(chapter) ? "fa-play-circle" : (weight === "far" ? "fa-circle" : "fa-check-circle");
      const color = this.isChapterActive(chapter) ? "text-white" : "text-rhubarb";
      return [weight, icon, color];
    }
  }
};
</script>

<template>
  <div id="accordion" class="h-100" course-sidebar-component>
    <div class="sidebar-header p-4 d-flex justify-content-between align-items-center bg-white">
      <h3 class="mb-0 font-weight-normal">{{ft("course.lessons")}}</h3>
      <a href="javascript: void(0)" @click="$emit('toggle-sidebar')" class="sidebar-close text-black">
        <i class="fal fa-times"></i>
      </a>
    </div>
    <div class="card rounded-0 border-top-0 border-right-0 border-left-0">
      <div class="card-body h-100 overflow-auto p-0" ref="courses">
        <template v-for="(chapter, index) in content.chapters">
          <ul v-if="chapter.chapters" class="list-unstyled mb-0">
            <li v-for="(subchapter, subindex) in chapter.chapters" class="p-3 d-flex border-top" :class="{'bg-rhubarb text-white': isChapterActive(subchapter)}" :key="`subchapter-${index}-${subindex}`">
              <div class="icon pr-3">
                <i :class="getIconClasses(subchapter, index + 1)"></i>
              </div>
              <a href="javascript: void(0)" class="item secondary" @click="setBookmark(subchapter, index)" :class="{'font-weight-bold': isChapterActive(subchapter)}">{{subchapter.title}}</a>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[course-sidebar-component] {
  // p-4 ($spacer * 1.5) top and bottom (* 2) + font size + some breath space
  $sidebar-header-height: ($spacer * 1.5) * 2 + $h3-font-size + 1;

  .sidebar-close {
    font-size: 2rem;
  }

  .card {
    height: calc(100vh - #{$sidebar-header-height});
  }

  .item {
    text-transform: none;
    font-size: $font-size-base;
    
    &.secondary {
      color: inherit;
    }
  }
}
</style>
